var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7532.21,-892.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-black",
    transform: "matrix(0.145417,0,0,0.186342,7128.69,833.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49022.5,-4471.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7542.64,900.052L7536.21,900.052C7535.84,900.052 7535.54,900.351 7535.54,900.719C7535.54,901.087 7535.84,901.386 7536.21,901.386L7537.54,901.386L7537.54,918.742C7537.54,920.214 7538.74,921.409 7540.21,921.409L7556.21,921.409C7557.68,921.409 7558.88,920.214 7558.88,918.742L7558.88,901.386L7560.21,901.386C7560.58,901.386 7560.88,901.087 7560.88,900.719C7560.88,900.351 7560.58,900.052 7560.21,900.052L7553.78,900.052L7553.78,898.295C7553.78,896.573 7552.39,895.175 7550.66,895.175C7550.66,895.175 7545.76,895.175 7545.76,895.175C7544.03,895.175 7542.64,896.573 7542.64,898.295L7542.64,900.052ZM7538.88,901.386L7538.88,918.742C7538.88,919.478 7539.48,920.075 7540.21,920.075C7540.21,920.075 7556.21,920.075 7556.21,920.075C7556.95,920.075 7557.54,919.478 7557.54,918.742L7557.54,901.386L7538.88,901.386ZM7548.88,915.928L7548.88,905.147C7548.88,904.779 7548.58,904.48 7548.21,904.48C7547.84,904.48 7547.54,904.779 7547.54,905.147L7547.54,915.928C7547.54,916.296 7547.84,916.595 7548.21,916.595C7548.58,916.595 7548.88,916.296 7548.88,915.928ZM7553.78,915.928L7553.78,905.147C7553.78,904.779 7553.49,904.48 7553.12,904.48C7552.75,904.48 7552.45,904.779 7552.45,905.147L7552.45,915.928C7552.45,916.296 7552.75,916.595 7553.12,916.595C7553.49,916.595 7553.78,916.296 7553.78,915.928ZM7543.97,915.906L7543.97,905.125C7543.97,904.757 7543.67,904.458 7543.3,904.458C7542.94,904.458 7542.64,904.757 7542.64,905.125L7542.64,915.906C7542.64,916.274 7542.94,916.572 7543.3,916.572C7543.67,916.572 7543.97,916.274 7543.97,915.906ZM7552.45,900.052L7552.45,898.295C7552.45,897.308 7551.65,896.508 7550.66,896.508L7545.76,896.508C7544.77,896.508 7543.97,897.308 7543.97,898.295L7543.97,900.052L7552.45,900.052Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.009c7cc8c99cb8845019b27e1901372f.svg";
export { ForwardRef as ReactComponent };